<template>
    <v-container grid-list-md text-center>
        <v-layout wrap>
            <v-flex xs12>
                <v-card color="grey lighten-5" class="mb-10" height="auto">
                    <v-card-title>
                        <h5>SMA Storage :</h5>
                        <v-spacer></v-spacer>
                        <v-text-field
                            v-model="$store.state.searchSmaStorageList"
                            append-icon="mdi-magnify"
                            label="Recherche"
                            single-line
                            hide-details>
                        </v-text-field>															
                    </v-card-title>
                    <v-data-table
                        :headers="$store.state.SmaStorageHeaders"
                        :items="$store.state.smaStorageListBool"
                        :items-per-page="15"
                        :single-select="true"
                        :search="$store.state.searchSmaStorageList"
                        :dense = true
                        item-key="ID"
                        class="elevation-1"
                    >
                        <template v-slot:top>
                            <v-toolbar
                                flat
                            >
                                <v-spacer></v-spacer>
                                <v-dialog
                                    v-model="dialogEdit"
                                    max-width="1200px"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            color="primary"
                                            dark
                                            class="mb-1"
                                            v-bind="attrs"
                                            v-on="on"
                                        >
                                            +
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-title>
                                            <span class="text-h5">{{ formTitle }}</span>
                                        </v-card-title>
                                        <FormulaireSmaStorage></FormulaireSmaStorage>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                color="blue darken-1"
                                                text
                                                @click="closeEdit"
                                            >
                                                Annuler
                                            </v-btn>
                                            <v-btn v-if="
                                                    $store.state.smaStorageEditedItem.REFERENCE != '' && 
                                                    $store.state.smaStorageEditedItem.SYSTEM_ID != '' && 
                                                    $store.state.smaStorageEditedItem.TYPE != '' "
                                                color="blue darken-1"
                                                text
                                                @click="saveEdit"
                                            >
                                                Enregistrer
                                            </v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                                <v-dialog
                                    v-model="dialogCopy"
                                    max-width="1200px"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                    </template>
                                    <v-card>
                                        <v-card-title>
                                            <span class="text-h5">Copier le composant SMA Storage</span>
                                        </v-card-title>
                                        <FormulaireSmaStorage></FormulaireSmaStorage>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                color="blue darken-1"
                                                text
                                                @click="closeCopy"
                                            >
                                                Annuler
                                            </v-btn>
                                            <v-btn v-if="
                                                    $store.state.smaStorageEditedItem.REFERENCE != '' && 
                                                    $store.state.smaStorageEditedItem.SYSTEM_ID != '' && 
                                                    $store.state.smaStorageEditedItem.TYPE != '' "
                                                color="blue darken-1"
                                                text
                                                @click="saveCopy"
                                            >
                                                Ajouter
                                            </v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                                <v-dialog v-model="dialogDelete" max-width="500px">
                                    <v-card>
                                        <v-card-title class="text-h5">Voulez-vous supprimer ce composant SMA Storage ?</v-card-title>
                                        <v-card-text>
                                            {{ $store.state.smaStorageEditedItem.REFERENCE }} {{ $store.state.smaStorageEditedItem.TYPE }}
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn color="blue darken-1" text @click="closeDelete">Annuler</v-btn>
                                            <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                                            <v-spacer></v-spacer>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </v-toolbar>
                        </template>
                        <template v-slot:item.actions="{ item }">
                            <v-icon
                                small
                                class="mr-2"
                                @click="copyItem(item)"
                            >
                                mdi-content-copy
                            </v-icon>
                            <v-icon
                                small
                                class="mr-2"
                                @click="editItem(item)"
                            >
                                mdi-pencil
                            </v-icon>
                            <v-icon
                                small
                                class="mr-2"
                                @click="deleteItem(item)"
                            >
                                mdi-delete
                            </v-icon>
                        </template>
                        <template v-slot:item.FullBlack="{ item }">
                            <v-simple-checkbox
                                v-model="item.FullBlack"
                                disabled
                            ></v-simple-checkbox>
                        </template>
                        <template v-slot:item.Bisun="{ item }">
                            <v-simple-checkbox
                                v-model="item.Bisun"
                                disabled
                            ></v-simple-checkbox>
                        </template>
                        <template v-slot:item.optimizer="{ item }">
                            <v-simple-checkbox
                                v-model="item.optimizer"
                                disabled
                            ></v-simple-checkbox>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
	import axios from 'axios';
    import createListBoolMixins from './mixins/createListBoolMixins.js';
	import FormulaireSmaStorage from './FormulaireSmaStorage.vue';

	export default {
    name: "GestionSmaStorage",
    components: { FormulaireSmaStorage },
    mixins: [
        createListBoolMixins,
    ],
    data: function () {
        return {
            dialogEdit: false,
            dialogCopy: false,
            dialogDelete: false,
            editedIndex: -1,
            formHasErrors: false,
            defaultItem: {
                REFERENCE: '',
                SYSTEM_ID: '',
                DESC_NL: '',
                DESC_FR: '',
                TYPE: '',
                QUANTITY: 0,
                DC_CURRENT: 0,
                DC_CABLE: 0,
                FAMILY: '',
                ACCESSORIES_PB: '',
            },
        };
    },
    computed: {
        formTitle() {
            return this.editedIndex === -1 ? "Nouveau composant SMA Storage" : "Modifier le composant SMA Storage";
        },
    },
    watch: {
        dialogEdit(val) {
            val || this.closeEdit();
        },
        dialogCopy(val) {
            val || this.closeCopy();
        },
        dialogDelete(val) {
            val || this.closeDelete();
        },
    },
    mounted() {
        this.createSmaStorageListBool();
    },
    methods: {
        getColor(admin) {
            if (admin == 0)
                return "red";
            else
                return "green";
        },
        editItem(item) {
            this.editedIndex = this.$store.state.smaStorageListBool.indexOf(item);
            this.$store.state.smaStorageEditedItem = Object.assign({}, item);
            this.dialogEdit = true;
        },
        copyItem(item) {
            this.editedIndex = this.$store.state.smaStorageListBool.indexOf(item);
            this.$store.state.smaStorageEditedItem = Object.assign({}, item);
            this.dialogCopy = true;
        },
        deleteItem(item) {
            this.editedIndex = this.$store.state.smaStorageListBool.indexOf(item);
            this.$store.state.smaStorageEditedItem = Object.assign({}, item);
            this.dialogDelete = true;
        },
        deleteItemConfirm() {
            this.$store.state.smaStorageListBool.splice(this.editedIndex, 1);
            this.closeDelete();
            var link = "http://3ur4p2zmartexkth.servebeer.com/domoserverDb/deleteSmaStorage.php";
            this.$store.state.axios_error = "";
            var data = this.$store.state.smaStorageEditedItem.ID;
            axios.post(link, data, {
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(response => {
                this.$store.state.smaStorageResponse = response;
                this.$store.state.api_status = response.data.api_status;
                this.$store.state.axios_error = "";
                if (response.data.smaStorageListSaved) {
                    link = "http://3ur4p2zmartexkth.servebeer.com/domoserverDb/loadSmaStorageList.php";
                    axios.get(link).then(response => {
                        this.$store.state.smaStorageList = response.data;
                        this.createSmaStorageListBool();
                    });
                }
            }).catch((error) => {
                this.$store.state.axios_error = error;
            });
        },
        closeEdit() {
            this.dialogEdit = false;
            this.$nextTick(() => {
                this.$store.state.smaStorageEditedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
        },
        closeCopy() {
            this.dialogCopy = false;
            this.$nextTick(() => {
                this.$store.state.smaStorageEditedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
        },
        closeDelete() {
            this.dialogDelete = false;
            this.$nextTick(() => {
                this.$store.state.smaStorageEditedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
        },
        saveEdit() {
            if (this.editedIndex > -1) {
                Object.assign(this.$store.state.smaStorageListBool[this.editedIndex], this.$store.state.smaStorageEditedItem);
                var link = "http://3ur4p2zmartexkth.servebeer.com/domoserverDb/editSmaStorage.php";
            }
            else {
                this.$store.state.smaStorageListBool.push(this.$store.state.smaStorageEditedItem);
                link = "http://3ur4p2zmartexkth.servebeer.com/domoserverDb/addSmaStorage.php";
            }
            this.closeEdit();
            this.$store.state.axios_error = "";
            var data = this.$store.state.smaStorageEditedItem;
            axios.post(link, data, {
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(response => {
                this.$store.state.smaStorageResponse = response;
                this.$store.state.api_status = response.data.api_status;
                this.$store.state.axios_error = "";
                if (response.data.smaStorageListSaved) {
                    link = "http://3ur4p2zmartexkth.servebeer.com/domoserverDb/loadSmaStorageList.php";
                    axios.get(link).then(response => {
                        this.$store.state.smaStorageList = response.data;
                        this.createSmaStorageListBool();
                    });
                }
            }).catch((error) => {
                this.$store.state.axios_error = error;
            });
        },
        saveCopy() {
            this.closeCopy();
            var link = "http://3ur4p2zmartexkth.servebeer.com/domoserverDb/addSmaStorage.php";
            this.$store.state.axios_error = "";
            var data = this.$store.state.smaStorageEditedItem;
            axios.post(link, data, {
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(response => {
                this.$store.state.smaStorageResponse = response;
                this.$store.state.api_status = response.data.api_status;
                this.$store.state.axios_error = "";
                if (response.data.smaStorageListSaved) {
                    link = "http://3ur4p2zmartexkth.servebeer.com/domoserverDb/loadSmaStorageList.php";
                    axios.get(link).then(response => {
                        this.$store.state.smaStorageList = response.data;
                        this.createSmaStorageListBool();
                    });
                }
            }).catch((error) => {
                this.$store.state.axios_error = error;
            });
        },
    },
}
</script>
